import { useMemo, useState } from 'react'
import { useApiListGroupUser, useApiListUserLogin } from '../../api-new/state/content'
import { ModalDialog } from '../component/modal-dialog'
import { TextFilter } from './text-filter'
import { ButtonPrimary } from '../component/button'

export const PermissionGroupUserModal = ({ target, groupID, allowAdd, allowDelete, onClose, onClosed }) => {
  const [filter, updateFilter] = useState('')

  const apiListUserLogin = useApiListUserLogin()
  const apiListGroupUser = useApiListGroupUser()

  const filteredItems = useMemo(
    () => {
      let lowerFilter = filter.toLowerCase()
      return apiListUserLogin.items.filter(i => i.email.toLowerCase().includes(lowerFilter))
    },
    [apiListUserLogin.items, filter]
  )

  const handleOpen = () => {
    updateFilter('')
    apiListUserLogin.get()
    apiListGroupUser.get(`${groupID}/group`)
  }
  const handleClose = () => onClose && onClose()

  const handleAdd = async userID => {
    await apiListGroupUser.post({ groupID: groupID, userID: userID })
    await apiListGroupUser.get(`${groupID}/group`)
  }

  const handleRemove = async userID => {
    await apiListGroupUser.delete(`${groupID}/${userID}`)
    await apiListGroupUser.get(`${groupID}/group`)
  }

  return (
    <ModalDialog target={target} header="Add User" fullScreen onOpen={handleOpen} onClose={onClosed}>
      <div className="d-flex flex-column h-100">
        <div>
          <TextFilter value={filter} onChange={updateFilter} />
        </div>
        <div className="flex-fill overflow-auto p-2">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 50 }} />
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((userLogin, i) =>
                  <Item
                    key={i}
                    userLogin={userLogin}
                    selectedGroupUsers={apiListGroupUser.items}
                    allowAdd={allowAdd}
                    allowDelete={allowDelete}
                    onAdd={handleAdd}
                    onRemove={handleRemove}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pt-1 border-top">
          <ButtonPrimary onClick={handleClose}>close</ButtonPrimary>
        </div>
      </div>
    </ModalDialog>
  )
}

const Item = ({ userLogin, selectedGroupUsers, allowAdd, allowDelete, onAdd, onRemove }) => {
  const isChecked = useMemo(() => selectedGroupUsers.findIndex(selectedGroupUser => selectedGroupUser.userID === userLogin.userID) !== -1, [
    userLogin,
    selectedGroupUsers
  ])

  const handleClick = () => {
    if (isChecked) {
      allowDelete && onRemove && onRemove(userLogin.userID)
    } else {
      allowAdd && onAdd && onAdd(userLogin.userID)
    }
  }

  return (
    <tr style={{ cursor: 'pointer' }} onClick={handleClick}>
      <td>
        <input className="form-check-input" type="checkbox" checked={isChecked} onChange={() => {}} />
      </td>
      <td>
        {userLogin.email}
      </td>
    </tr>
  )
}
